import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import api from '../api/axios';
import { useLanguage } from '../contexts/LanguageContext';

const ForgotPassword = () => {
  const [username, setUsername] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const { t } = useLanguage();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await api.post('/api/auth/forgot-password', { username: username.trim() });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || t('auth.forgotPasswordFailed'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container className="py-5" style={{ maxWidth: '440px' }}>
      <Card className="p-4">
        <h2 className="mb-4 text-center">{t('auth.forgotPasswordTitle')}</h2>

        {done ? (
          <Alert variant="success">
            {t('auth.forgotPasswordSent')}
            <div className="mt-2">
              <Link to="/login">{t('auth.backToLogin')}</Link>
            </div>
          </Alert>
        ) : (
          <>
            <p className="text-muted mb-3">{t('auth.forgotPasswordInstructions')}</p>

            {error && <Alert variant="danger">{error}</Alert>}

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>{t('auth.username')}</Form.Label>
                <Form.Control
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  autoFocus
                />
              </Form.Group>

              <Button
                type="submit"
                variant="primary"
                className="w-100"
                disabled={submitting}
              >
                {submitting ? t('common.loading') : t('auth.forgotPasswordSubmit')}
              </Button>
            </Form>

            <div className="text-center mt-3">
              <Link to="/login">{t('auth.backToLogin')}</Link>
            </div>
          </>
        )}
      </Card>
    </Container>
  );
};

export default ForgotPassword;
